var _desc, _g, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 30",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Delivered ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) ",
    points: "24 0 0 0 0 24 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5148634,12.2594776 L10.7057299,16.2160027 L21.9822774,5.45735526 C22.2819718,5.17142497 22.7567144,5.18258299 23.0426447,5.4822774 C23.328575,5.78197182 23.317417,6.25671445 23.0177226,6.54264474 L11.2261698,17.7926447 C10.9374898,18.0680665 10.4837074,18.069259 10.1935838,17.7953583 L5.4851366,13.3501942 C5.18394352,13.065843 5.17029049,12.5911656 5.4546417,12.2899725 C5.7389929,11.9887794 6.21367033,11.9751264 6.5148634,12.2594776 Z M0.985136598,13.3501942 C0.683943525,13.065843 0.670290493,12.5911656 0.954641698,12.2899725 C1.2389929,11.9887794 1.71367033,11.9751264 2.0148634,12.2594776 L6.72331061,16.7046417 C7.02450368,16.9889929 7.03815671,17.4636703 6.75380551,17.7648634 C6.4694543,18.0660565 5.99477688,18.0797095 5.6935838,17.7953583 L0.985136598,13.3501942 Z M11.5932972,13.1490508 C11.2936028,13.4349811 10.8188602,13.423823 10.5329299,13.1241286 C10.2469996,12.8244342 10.2581576,12.3496916 10.557852,12.0637613 L17.4822774,5.45735526 C17.7819718,5.17142497 18.2567144,5.18258299 18.5426447,5.4822774 C18.828575,5.78197182 18.817417,6.25671445 18.5177226,6.54264474 L11.5932972,13.1490508 Z",
    fill: "#34B7F1",
    fillRule: "nonzero"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 39,
    fill: "#34B7F1",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Ruslan Mirsalikhov")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 44,
    fill: "#34B7F1",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeenIcon);
export default __webpack_public_path__ + "static/media/seen-icon.98e38ca62c08a0b0dd170b084f36a048.svg";
export { ForwardRef as ReactComponent };